export default "__VITE_ASSET__wW1Dcqfb__"